// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import { observer } from 'mobx-react';
import React, { Component } from 'react';
import classnames from 'classnames';
import { getOr, isNil, isEmpty } from 'lodash/fp';
import { backgroundColor } from 'logic/data/Izenda.UIConstants';

@observer
export default class ChartContainer extends Component {
  render() {
    const props = this.props;
    const { printingMode, style, className, children } = props;
    const commonOptions = getOr({}, 'chartOptions.commonOptions', props);
    const containerStyle = {
      borderStyle: commonOptions['izEntire.borderStyle'] || 'solid',
      borderColor: commonOptions['izEntire.borderColor'],
      borderWidth: commonOptions['izEntire.borderWidth'] || 0,
      backgroundColor: commonOptions['izEntire.backgroundColor'] || backgroundColor,
      height: printingMode ? style.height : null
    };

    const classes = classnames('izenda-ChartContainer izenda-Wrapper', className, { printing: printingMode });

    return (
      <section ref={this.setBackgroundColorImportant} className={classes} style={containerStyle}>
        {children}
      </section>
    );
  }

  /**
   * Set important inline style for background setting
   * Avoid override by bootstrap CSS
   */
  setBackgroundColorImportant = (dom: any) => {
    if (!isNil(dom)) {
      const color = dom.style.backgroundColor;
      !isEmpty(color) && dom.style.setProperty('background-color', color, 'important');
    }
  };
}



// WEBPACK FOOTER //
// ./ui/share/components/charting/Izenda.ChartContainer.js